import React, { PureComponent } from 'react';
import strings from 'helper/localization/localization';

export default class SignupYearOfBirth extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      yearOfBirth: this.props.user.yearOfBirth || 1990,
    };

    this.currentYear = new Date().getFullYear();

    this.updateDetails = this.props.updateDetails;
    this.tooYoung = this.props.tooYoung;
    this.toNextStep = this.toNextStep.bind(this);
    this.yearOfBirthChanged = this.yearOfBirthChanged.bind(this);
  }

  toNextStep(e) {
    e.preventDefault();

    const cutoffYear = this.currentYear - 16;
    if (this.state.yearOfBirth > cutoffYear) {
      this.tooYoung();
    } else {
      this.updateDetails('yearOfBirth', this.state.yearOfBirth);
    }
  }

  yearOfBirthChanged(e) {
    this.setState({ yearOfBirth: e.target.value });
  }

  render() {
    // Create year options
    const years = [];
    for (let i = this.currentYear; i > 1900; i -= 1) {
      years.push(<option value={i} key={i}>{i}</option>);
    }

    return (
      <form>
        <div className="form-group">
          <label htmlFor="signup--yob">{strings.whatIsYourYearOfBirth}</label>
          <select
            className="form-control"
            id="signup--yob"
            defaultValue={this.state.yearOfBirth}
            onChange={this.yearOfBirthChanged}
          >
            {years}
          </select>
        </div>
        <button
          type="submit"
          className="btn btn-outline-primary btn-lg btn-block"
          onClick={this.toNextStep}
          id="signup-yob--save"
        >
          {strings.next}
        </button>
      </form>
    );
  }
}



// WEBPACK FOOTER //
// ./src/modules/signup/components/SignupYearOfBirth.jsx